export default {
  state: {
    blocks: [],
    isLoading: false,
  },

  getters: {
    blockById: (state) => (id) => {
      if (state.blocks.length === 0) return null
      return state.blocks.find(bl => bl.id === id)
    }

  },

  actions: {
    getBlocks({ commit, dispatch }, { $api }) {
      commit('setLoading', true)
      $api.get('blocks/')
        .then((response) => {
          commit('setBlocks', response.data)
          commit('setLoading', false)
        })
        .catch(error => dispatch('throwError', error))
    },

  },

  mutations: {
    setBlocks(state, data) {
      state.blocks = data
    },
    setLoading(state, data) {
      state.isLoading = data
    },
  }
}
